import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Grid, TextField } from '@material-ui/core';
import { isEmpty } from 'lodash';

import FormSubmitButton from '../FormSubmitButton';
import Dropzone from '../Dropzone';
import AutoSuggestionSelect from '../AutoSuggestionSelect';
import Progress from '../../containers/ProgressContainer';
import Snackbar from '../../containers/SnackbarContainer';

import months from '../../utils/months';

const styles = {
  container: {
    padding: '30px',
  },
};

class ManualTab extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      identity_number: '',
      month: null,
      year: '',
      files: [],
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleMonthChange = this.handleMonthChange.bind(this);
    this.onDrop = this.onDrop.bind(this);
  }

  onDrop(files) {
    this.setState({ files });
  }

  handleChange(event) {
    const { name, value } = event.target;
    if (name === 'identity_number') this.props.search({ 'q[employee_profile_identity_number_eq]': value });
    this.setState({ [name]: value });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { createPaycheck, users, showSnackbar } = this.props;
    const { files, year, month } = this.state;

    if (month && !isEmpty(users)) {
      const paycheck = new FormData();

      paycheck.append('paycheck[file]', files[0]);
      paycheck.append('paycheck[month]', month.value);
      paycheck.append('paycheck[year]', year);
      paycheck.append('paycheck[employee_id]', users[0].id);

      createPaycheck(paycheck);
    } else if (isEmpty(users)) {
      showSnackbar('No existe un usuario con ese numero de cedula.', 'error');
    } else {
      showSnackbar('Es necesario ingresar el mes.', 'error');
    }
  }

  handleMonthChange(value) {
    this.setState({ month: value });
  }

  render() {
    const { identity_number, month, year } = this.state;
    const { classes, isFetching, users } = this.props;

    return (
      <form onSubmit={this.handleSubmit}>
        <Grid container className={classes.container} alignItems="center" spacing={32}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              value={identity_number}
              type="text"
              label="CI"
              name="identity_number"
              inputProps={{
                maxLength: 8,
                minLength: 8,
              }}
              onChange={this.handleChange}
            />
          </Grid>
          { !isEmpty(users) && identity_number && <Grid item xs={12} sm={6}>
            <TextField
              disabled
              fullWidth
              value={`${users[0].first_name} ${users[0].last_name}`}
              type="text"
              name="name"
            />
          </Grid> }
          { !isEmpty(users) && identity_number && <Grid item xs={12} sm={6}>
            <TextField
              disabled
              fullWidth
              value={users[0].employee_profile.employee_number}
              type="text"
              name="employee_number"
            />
          </Grid> }
          <Grid item xs={6}>
            <AutoSuggestionSelect
              required
              value={month}
              options={months}
              placeholder="Mes"
              label="Mes"
              onChange={this.handleMonthChange}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              required
              value={year}
              type="text"
              label="Año"
              name="year"
              inputProps={{
                maxLength: 4,
                minLength: 4,
              }}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <Dropzone onDrop={this.onDrop} />
          </Grid>
          <FormSubmitButton />
          { isFetching && <Progress /> }
          <Snackbar />
        </Grid>
      </form>
    );
  }
}

export default withStyles(styles)(ManualTab);

ManualTab.propTypes = {
  classes: PropTypes.object.isRequired,
  search: PropTypes.func.isRequired,
  createPaycheck: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  users: PropTypes.array.isRequired,
  showSnackbar: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Paychecks/ManualTab.js